import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Column, ConfirmationModal, TextField, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
export const GetAppleNameCaptureModalTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            AppleNameCaptureModalTID: {
                Modal: 'apple-name-modal',
                FirstName: 'apple-name-first',
                LastName: 'apple-name-last',
                Save: 'apple-name-save',
                SaveError: 'apple-name-save-error'
            }
        }
    });
export function AppleNameCaptureModal(param) {
    let { dismissModal, testId } = param;
    const { t: authTexts } = useLocaleKeys('auth.screens');
    const { api } = useStoreActions();
    const { AppleNameCaptureModalTID } = useMemo(()=>GetAppleNameCaptureModalTID(testId), [
        testId
    ]);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [saveFailed, setSaveFailed] = useState(false);
    const firstNameInvalid = submitted && firstName.trim() === '';
    const lastNameInvalid = submitted && lastName.trim() === '';
    async function handleSave() {
        setSubmitted(true);
        if (firstName.trim() === '' || lastName.trim() === '') return;
        setSaveFailed(false);
        try {
            await api.auth.editUserDetails({
                name: {
                    first: firstName.trim().slice(0, 100),
                    last: lastName.trim().slice(0, 100)
                }
            });
        } catch (unused) {
            setSaveFailed(true);
            return;
        }
        dismissModal === null || dismissModal === void 0 ? void 0 : dismissModal();
    }
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        testId: AppleNameCaptureModalTID.Modal(),
        title: authTexts.appleNamePromptTitle(),
        textAlignCenter: false,
        primaryButtonLabel: authTexts.appleNamePromptSave(),
        primaryButtonTestId: AppleNameCaptureModalTID.Save(),
        onPrimaryButtonClick: handleSave,
        onCloseButtonClick: dismissModal,
        bi: {
            primaryButton: {
                name: 'apple_name_capture_save'
            },
            secondaryButton: {
                name: 'apple_name_capture_skip'
            }
        },
        content: /*#__PURE__*/ _jsxs(Column, {
            gap: 16,
            children: [
                /*#__PURE__*/ _jsx(TextField, {
                    label: authTexts.appleFirstNameLabel(),
                    testId: AppleNameCaptureModalTID.FirstName(),
                    bi: {
                        name: 'apple_name_first'
                    },
                    value: firstName,
                    onChange: (e)=>setFirstName(e.currentTarget.value),
                    error: firstNameInvalid,
                    helperText: firstNameInvalid ? authTexts.appleNameRequired() : undefined
                }),
                /*#__PURE__*/ _jsx(TextField, {
                    label: authTexts.appleLastNameLabel(),
                    testId: AppleNameCaptureModalTID.LastName(),
                    bi: {
                        name: 'apple_name_last'
                    },
                    value: lastName,
                    onChange: (e)=>setLastName(e.currentTarget.value),
                    error: lastNameInvalid,
                    helperText: lastNameInvalid ? authTexts.appleNameRequired() : undefined
                }),
                saveFailed && /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    skin: "error",
                    testId: AppleNameCaptureModalTID.SaveError(),
                    children: authTexts.appleNameSaveError()
                })
            ]
        })
    });
}
